module.exports = __webpack_public_path__ + "static/media/icon-dev-ic-home.cd764bfe.svg";